const getToken = state => state?.auth?.token
const getCorporateId = state => state?.auth?.corporateId
const getCorporateData = state => state?.auth?.corporateData
const getUserRoleList = state => state?.auth?.userRoleList
const getUserId = state => state?.auth?.userId
const getUserData = state => state?.auth?.userData
const getListOfCountries = state => state?.auth?.listOfCountries
const getListOfStates = state => state?.auth?.listOfStates
const getListOfCities = state => state?.auth?.listOfCities
const getDashboardData = state => state?.auth?.dashboardData
const getDashboardNavs = state => state?.auth?.dashboardNavs
const getNotificationData = state => state?.auth?.notificationData
const getUserPermissions = state => state?.auth?.permissions

const selectors = {
  getToken,
  getCorporateId,
  getCorporateData,
  getUserRoleList,
  getUserId,
  getUserData,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  getDashboardData,
  getDashboardNavs,
  getNotificationData,
  getUserPermissions
}

export default selectors
